import React from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  TextField,
  IconButton,
  Switch,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Chip,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
} from "@mui/icons-material";
import { DndContext } from "@dnd-kit/core";
import { SortableContext } from "@dnd-kit/sortable";

const BeerillionerConfigTab = (props) => {
  const {
    gameName,
    setGameName,
    fffTimer,
    setFffTimer,
    questionTimer,
    setQuestionTimer,
    audiencePlayEnabled,
    setAudiencePlayEnabled,
    audienceTimer,
    setAudienceTimer,
    saveGeneralConfig,
    saveLoading,
    prizes,
    handleAddPrize,
    openEditPrize,
    handleDeletePrize,
    config,
    API_BASE,
    lifelines,
    setConfig,
    saveLifeline,
    df,
    setSetDialogOpen,
    openAddQ,
    viewSetId,
    setViewSetId,
    loadQuestions,
    questionSets,
    handleDeleteSet,
    questions,
    sensors,
    closestCenter,
    handleDragEnd,
    verticalListSortingStrategy,
    SortableQuestionRow,
    openEditQ,
    deleteQuestion,
    fffStoredQuestions,
    deleteFFFQ,
  } = props;

  return (
          <Box>
            <Paper sx={{ p: 3, bgcolor: "#1a1a1a", mb: 3 }}>
              <Typography
                variant="h6"
                sx={{ color: "#fff", mb: 2 }}>
                General Settings
              </Typography>
              <Grid
                container
                spacing={2}>
                <Grid
                  item
                  xs={12}
                  sm={4}>
                  <TextField
                    fullWidth
                    label="Game Name"
                    value={gameName}
                    onChange={(e) => setGameName(e.target.value)}
                    sx={df}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={4}>
                  <TextField
                    fullWidth
                    label="FFF Timer (sec)"
                    type="number"
                    value={fffTimer}
                    onChange={(e) => setFffTimer(Number(e.target.value))}
                    sx={df}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={4}>
                  <TextField
                    fullWidth
                    label="Question Timer (0=none)"
                    type="number"
                    value={questionTimer}
                    onChange={(e) => setQuestionTimer(Number(e.target.value))}
                    sx={df}
                  />
                </Grid>
              </Grid>
              <Box
                sx={{
                  mt: 3,
                  p: 2,
                  bgcolor: "#222",
                  borderRadius: 1,
                  border: "1px solid #444",
                }}>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#e040fb", mb: 1.5 }}>
                  Audience Play Mode
                </Typography>
                <Grid
                  container
                  spacing={2}
                  alignItems="center">
                  <Grid
                    item
                    xs={12}
                    sm={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={audiencePlayEnabled}
                          onChange={(e) =>
                            setAudiencePlayEnabled(e.target.checked)
                          }
                        />
                      }
                      label={
                        <Typography sx={{ color: "#fff" }}>
                          Enable Audience Play
                        </Typography>
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={4}>
                    <TextField
                      fullWidth
                      label="Audience Timer (sec)"
                      type="number"
                      value={audienceTimer}
                      onChange={(e) => setAudienceTimer(Number(e.target.value))}
                      disabled={!audiencePlayEnabled}
                      sx={df}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={4}>
                    <Typography
                      variant="caption"
                      sx={{ color: "#888" }}>
                      Audience gets limited time to answer each question. Timer
                      starts when options are revealed.
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                onClick={saveGeneralConfig}
                disabled={saveLoading}
                sx={{
                  mt: 2,
                  bgcolor: "#ffd700",
                  color: "#000",
                  "&:hover": { bgcolor: "#e6c200" },
                }}>
                Save
              </Button>
            </Paper>

            {/* Prize Ladder with topic + difficulty */}
            <Paper sx={{ p: 3, bgcolor: "#1a1a1a", mb: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}>
                <Typography
                  variant="h6"
                  sx={{ color: "#fff" }}>
                  Prize Ladder ({prizes.length} levels)
                </Typography>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={handleAddPrize}
                  sx={{
                    bgcolor: "#ffd700",
                    color: "#000",
                    "&:hover": { bgcolor: "#e6c200" },
                  }}>
                  Add Level
                </Button>
              </Box>
              {[...prizes].reverse().map((prize) => (
                <Box
                  key={prize.id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 1,
                    p: 1.5,
                    borderRadius: 1,
                    bgcolor: prize.is_checkpoint
                      ? "rgba(184,134,11,0.15)"
                      : "#222",
                    border: `1px solid ${prize.is_checkpoint ? "#b8860b" : "#333"}`,
                    flexWrap: "wrap",
                  }}>
                  <Chip
                    label={`${prize.level}`}
                    size="small"
                    sx={{
                      bgcolor: "#4a6741",
                      color: "#fff",
                      fontWeight: 700,
                      minWidth: 36,
                    }}
                  />
                  {prize.is_checkpoint && (
                    <Chip
                      label="CP"
                      size="small"
                      sx={{ bgcolor: "#b8860b", color: "#fff" }}
                    />
                  )}
                  {prize.image_url && (
                    <Box
                      component="img"
                      src={
                        prize.image_url.startsWith("http")
                          ? prize.image_url
                          : `${API_BASE}/${prize.image_url}`
                      }
                      sx={{
                        width: 28,
                        height: 28,
                        borderRadius: 1,
                        objectFit: "cover",
                      }}
                    />
                  )}
                  <Typography
                    variant="body2"
                    sx={{ color: "#fff", flex: 1, minWidth: 80 }}>
                    {prize.label || "—"}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ color: "#888", minWidth: 60 }}>
                    {prize.value_text || "—"}
                  </Typography>
                  <Chip
                    size="small"
                    label={
                      (prize.topic_ids || []).length === 0
                        ? "Any"
                        : (prize.topic_ids || [])
                            .map(
                              (id) =>
                                (config?.topics || []).find((t) => t.id === id)
                                  ?.display_name ||
                                (config?.topics || []).find((t) => t.id === id)
                                  ?.topic_name,
                            )
                            .filter(Boolean)
                            .join(", ") || "Any"
                    }
                    sx={{
                      bgcolor: "#333",
                      color: "#aaa",
                      fontSize: "0.7rem",
                      maxWidth: 120,
                    }}
                  />
                  <Chip
                    size="small"
                    label={
                      (prize.difficulty_ids || []).length === 0
                        ? "Any"
                        : (prize.difficulty_ids || [])
                            .map(
                              (id) =>
                                (config?.difficulties || []).find(
                                  (d) => d.id === id,
                                )?.level_name,
                            )
                            .filter(Boolean)
                            .join(", ") || "Any"
                    }
                    sx={{
                      bgcolor: "#333",
                      color: "#aaa",
                      fontSize: "0.7rem",
                      maxWidth: 100,
                    }}
                  />
                  <IconButton
                    size="small"
                    onClick={() => openEditPrize(prize)}
                    sx={{ color: "#90caf9" }}
                    title="Edit">
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => handleDeletePrize(prize.id)}
                    sx={{ color: "#ef5350" }}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))}
              {prizes.length === 0 && (
                <Typography sx={{ color: "#666", textAlign: "center", py: 2 }}>
                  No prize levels yet.
                </Typography>
              )}
            </Paper>

            {/* Lifelines */}
            <Paper sx={{ p: 3, bgcolor: "#1a1a1a", mb: 3 }}>
              <Typography
                variant="h6"
                sx={{ color: "#fff", mb: 2 }}>
                Lifelines
              </Typography>
              {lifelines.map((ll) => (
                <Box
                  key={ll.id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mb: 1,
                    p: 1,
                    borderRadius: 1,
                    bgcolor: "#222",
                  }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={!!ll.is_enabled}
                        onChange={(e) => {
                          setConfig((prev) => ({
                            ...prev,
                            lifelines: lifelines.map((l) =>
                              l.id === ll.id
                                ? { ...l, is_enabled: e.target.checked ? 1 : 0 }
                                : l,
                            ),
                          }));
                          saveLifeline({
                            ...ll,
                            is_enabled: e.target.checked ? 1 : 0,
                          });
                        }}
                      />
                    }
                    label=""
                  />
                  <TextField
                    size="small"
                    value={ll.label}
                    onChange={(e) => {
                      setConfig((prev) => ({
                        ...prev,
                        lifelines: lifelines.map((l) =>
                          l.id === ll.id ? { ...l, label: e.target.value } : l,
                        ),
                      }));
                    }}
                    onBlur={() => saveLifeline(ll)}
                    sx={{ flex: 1, ...df }}
                  />
                  <TextField
                    size="small"
                    type="number"
                    label="Add to Q timer (s)"
                    inputProps={{ min: 0 }}
                    value={ll.extra_timer_seconds ?? 0}
                    onChange={(e) => {
                      const raw = e.target.value;
                      const v = raw === "" ? 0 : Math.max(0, parseInt(raw, 10) || 0);
                      setConfig((prev) => ({
                        ...prev,
                        lifelines: (prev.lifelines || []).map((l) =>
                          l.id === ll.id ? { ...l, extra_timer_seconds: v } : l,
                        ),
                      }));
                    }}
                    onBlur={() => {
                      const cur = (config?.lifelines || []).find((l) => l.id === ll.id);
                      if (cur) saveLifeline(cur);
                    }}
                    sx={{ width: 140, ...df }}
                  />
                  <Chip
                    label={ll.type}
                    size="small"
                    sx={{ bgcolor: "#333", color: "#aaa" }}
                  />
                </Box>
              ))}
            </Paper>

            {/* Questions */}
            <Paper sx={{ p: 3, bgcolor: "#1a1a1a", mb: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}>
                <Typography
                  variant="h6"
                  sx={{ color: "#fff" }}>
                  Main Game Questions
                </Typography>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => setSetDialogOpen(true)}
                    sx={{ color: "#ffd700", borderColor: "#ffd700" }}>
                    New Set
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => openAddQ("main")}
                    sx={{
                      bgcolor: "#ffd700",
                      color: "#000",
                      "&:hover": { bgcolor: "#e6c200" },
                    }}>
                    Add Question
                  </Button>
                </Box>
              </Box>
              <Box
                sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}>
                <FormControl
                  size="small"
                  sx={{ minWidth: 200 }}>
                  <InputLabel sx={{ color: "#aaa" }}>Select Set</InputLabel>
                  <Select
                    value={viewSetId}
                    onChange={(e) => {
                      setViewSetId(e.target.value);
                      loadQuestions(e.target.value || undefined);
                    }}
                    label="Select Set"
                    sx={{
                      color: "#fff",
                      "& fieldset": { borderColor: "#555" },
                    }}>
                    <MenuItem value="">All Questions</MenuItem>
                    {questionSets.map((s) => (
                      <MenuItem
                        key={s.id}
                        value={s.id}>
                        {s.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {viewSetId && (
                  <IconButton
                    size="small"
                    onClick={() => handleDeleteSet(viewSetId)}
                    sx={{ color: "#ef5350" }}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                )}
                <Typography
                  variant="body2"
                  sx={{ color: "#888" }}>
                  {questions.length} question{questions.length !== 1 ? "s" : ""}
                </Typography>
              </Box>
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}>
                <SortableContext
                  items={questions.map((q) => q.id)}
                  strategy={verticalListSortingStrategy}>
                  <List dense>
                    {questions.map((q) => (
                      <SortableQuestionRow
                        key={q.id}
                        question={q}
                        onEdit={(q) => openEditQ(q, "main")}
                        onDelete={deleteQuestion}
                        prizes={prizes}
                        topics={config?.topics || []}
                        difficulties={config?.difficulties || []}
                      />
                    ))}
                  </List>
                </SortableContext>
              </DndContext>
              {questions.length === 0 && (
                <Typography sx={{ color: "#666", textAlign: "center", py: 3 }}>
                  No questions{viewSetId ? " in this set" : ""}.
                </Typography>
              )}
            </Paper>

            {/* FFF Questions */}
            <Paper sx={{ p: 3, bgcolor: "#1a1a1a" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}>
                <Typography
                  variant="h6"
                  sx={{ color: "#fff" }}>
                  FFF Questions ({fffStoredQuestions.length})
                </Typography>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => openAddQ("fff")}
                  sx={{
                    bgcolor: "#e65100",
                    color: "#fff",
                    "&:hover": { bgcolor: "#bf360c" },
                  }}>
                  Add FFF Question
                </Button>
              </Box>
              <List dense>
                {fffStoredQuestions.map((q) => (
                  <ListItem
                    key={q.id}
                    sx={{
                      bgcolor: "#1e1e1e",
                      mb: 0.5,
                      borderRadius: 1,
                      border: "1px solid #333",
                    }}>
                    <ListItemText
                      primary={
                        <Typography
                          noWrap
                          sx={{ maxWidth: 500, color: "#fff" }}>
                          {q.question_text}
                        </Typography>
                      }
                      secondary={
                        <Typography
                          variant="caption"
                          sx={{ color: "#aaa" }}>
                          Answer: {q.correct_answer}
                        </Typography>
                      }
                    />
                    <ListItemSecondaryAction>
                      <IconButton
                        size="small"
                        onClick={() => openEditQ(q, "fff")}
                        sx={{ color: "#90caf9" }}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => deleteFFFQ(q.id)}
                        sx={{ color: "#ef5350" }}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
              </List>
              {fffStoredQuestions.length === 0 && (
                <Typography sx={{ color: "#666", textAlign: "center", py: 3 }}>
                  No FFF questions yet.
                </Typography>
              )}
            </Paper>
          </Box>
  );
};

export default BeerillionerConfigTab;
